import { render, staticRenderFns } from "./WordCloud.vue?vue&type=template&id=a6a4f1d8"
import script from "./WordCloud.vue?vue&type=script&lang=js"
export * from "./WordCloud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pikkle/Dev/eM+/muse/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6a4f1d8')) {
      api.createRecord('a6a4f1d8', component.options)
    } else {
      api.reload('a6a4f1d8', component.options)
    }
    module.hot.accept("./WordCloud.vue?vue&type=template&id=a6a4f1d8", function () {
      api.rerender('a6a4f1d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Visualisations/WordCloud.vue"
export default component.exports